/**
 * Basılı menü tasarımları.
 *
 * NEDEN BÖYLE:
 *  · Arka planlar hazır TASARIM (çerçeve, illüstrasyon, fırça/pil başlıkları).
 *    Ürün çizgileri ve daireler tasarımdan TEMİZLENDİ (scripts/clean-menu-templates.py)
 *    çünkü bizim satır aralığımız onların çizgi aralığına uymuyor; yazı
 *    çizginin üstüne binince menü okunaksız oluyordu.
 *  · Ortalanan başlıklar tasarımın KENDİ ekseniyle hizalanır: süslemeler
 *    ölçüldü, beşinde de eksen sayfa ortası (x=50) — kutu ona göre kurulur.
 *  · Tüm ölçüler SAYFA YÜZDESİ: sayfa ekranda 210mm, kâğıtta A4 — aynı oran,
 *    tek geometri. (px verilseydi önizleme ile çıktı ayrışırdı.)
 *  · İki yerleşim türü:
 *      `body`  → serbest akış: kaç kategori/ürün olursa olsun akar (ottoman,
 *                noir, fresh). Kategori başlığını biz çiziyoruz (daire+simge).
 *      `slots` → bölmeli: tasarımın kendi fırça/pil başlıkları duruyor, her
 *                bölmeye BİR kategori giriyor (rustic, garden). Tasarımın
 *                kimliği korunuyor ama en fazla 5 kategori sığıyor.
 *  · Arka plan `background-image` DEĞİL `<img>`: tarayıcı yazdırırken arka plan
 *    grafiklerini varsayılan olarak ATAR, resmi atmaz. Aynı sebeple daireler
 *    SVG, kılavuz çizgileri `border` ile çizilir.
 *  · Görseller `src/assets` altından İÇERİ AKTARILIR: Vite adlarına içerik
 *    hash'i koyar, dosya değişince adres de değişir. `public/` altında adres
 *    sabit kalıyordu ve nginx bu uzantılara `immutable, 1 yıl` verdiği için
 *    Cloudflare eski görseli sunmaya devam ediyordu (20 Eki 2026).
 */
import ottomanBg from './assets/menu-tpl/ottoman.jpg';
import noirBg from './assets/menu-tpl/noir.jpg';
import freshBg from './assets/menu-tpl/fresh.jpg';
import rusticBg from './assets/menu-tpl/rustic.jpg';
import gardenBg from './assets/menu-tpl/garden.jpg';

export const MENU_TEMPLATES = [
  {
    key: 'ottoman',
    bg: ottomanBg,
    ink: '#463123', soft: '#8a7357', rule: '#c4ab8b', disc: '#eadcc5', onPill: '#fff',
    // Tasarımın QR çerçevesi ölçüldü: x 77.8–92.3, y 3.35–14.08 (sayfa %).
    qr: { cx: 85.0, cy: 8.7, size: 12.5 },
    cap: { x: 75.0, y: 14.5, w: 20 },
    title: { x: 19, y: 8.8, w: 62, align: 'center' },
    body: { x: 8, y: 20.6, w: 84, h: 62, cols: 1 },
  },
  {
    key: 'noir',
    bg: noirBg,
    ink: '#efe6d2', soft: '#b9a880', rule: '#8d7a50', disc: '#2a2a28', onPill: '#fff',
    // Altın çerçeve: x 79.4–93.4, y 4.0–13.1.
    qr: { cx: 86.4, cy: 8.55, size: 11.0 },
    cap: { x: 76.4, y: 13.6, w: 20 },
    title: { x: 19, y: 11.0, w: 62, align: 'center' },
    body: { x: 9, y: 19.2, w: 82, h: 71, cols: 1 },
  },
  {
    key: 'fresh',
    bg: freshBg,
    ink: '#2d3b36', soft: '#7b8a84', rule: '#e8a898', disc: '#fbdcd4', onPill: '#fff',
    // Mercan köşe işaretleri: x 80.9–94.8, y 4.0–14.4.
    qr: { cx: 87.8, cy: 9.2, size: 12.0 },
    cap: { x: 77.3, y: 15.0, w: 21 },
    // Zeytin dalı y 3–7.5 arasında ortada duruyor; ad onun ALTINA, yanlardaki
    // kısa çizgilerin (y=12) hizasına ortalanır.
    // Kutu, yanlardaki kısa çizgilerin arasına (x 33.3–66.4) sığar: uzun ad
    // çizgilerin üstüne binmesin, alt satıra insin.
    title: { x: 34, y: 10.8, w: 32, align: 'center' },
    body: { x: 5.5, y: 18.6, w: 89, h: 66, cols: 2, gap: 8 },
  },
  {
    key: 'rustic',
    bg: rusticBg,
    ink: '#4a3a2c', soft: '#8b7760', rule: '#c0a98c', onPill: '#fff',
    // Sağ üst köşe boş kâğıt; fotoğraf %20.3'te başlıyor → yazı ondan önce biter.
    qr: { cx: 87.0, cy: 9.4, size: 13.0 },
    cap: { x: 78.0, y: 14.6, w: 18 },
    // Kutu, iki kırmızı süsleme arasına (x 35 ve 64.6) sığacak kadar dar:
    // uzun ad süslemenin üstüne binmesin, alt satıra insin.
    title: { x: 36, y: 7.2, w: 28, align: 'center' },
    // Fırça başlıkları tasarımın kendisi: kategori adı fırçanın ÜSTÜNE,
    // simge çizginin sağ ucuna oturur.
    slots: [
      { name: { x: 6, y: 17.1, w: 24, h: 4.1 }, icon: { cx: 40, cy: 19.1, size: 4.4 }, items: { x: 7, y: 22.0, w: 60, h: 14.2 } },
      { name: { x: 6, y: 37.1, w: 24, h: 4.1 }, icon: { cx: 40, cy: 39.1, size: 4.4 }, items: { x: 7, y: 42.0, w: 60, h: 14.2 } },
      { name: { x: 6, y: 57.1, w: 24, h: 4.1 }, icon: { cx: 40, cy: 59.1, size: 4.4 }, items: { x: 7, y: 62.0, w: 60, h: 6.2 } },
      { name: { x: 6, y: 69.1, w: 24, h: 4.1 }, icon: { cx: 40, cy: 71.1, size: 4.4 }, items: { x: 7, y: 74.0, w: 60, h: 5.2 } },
      { name: { x: 6, y: 79.9, w: 24, h: 4.1 }, icon: { cx: 40, cy: 81.9, size: 4.4 }, items: { x: 7, y: 85.0, w: 60, h: 9.5 } },
    ],
  },
  {
    key: 'garden',
    bg: gardenBg,
    ink: '#2f3b32', soft: '#7d8a7c', rule: '#c3cdc2', onPill: '#fff',
    // Beyaz kart: x 78.2–92.9, y 3.3–13.75 (iç çerçeve 79.3–91.9 / 4.4–12.7).
    // Yazı kartın ALTINA, koyu yeşil şeride: beyaz yazı beyaz kartta kayboluyordu.
    qr: { cx: 85.6, cy: 8.55, size: 10.6 },
    cap: { x: 74.5, y: 14.3, w: 22, onDark: true },
    // Sol yarı başlık alanı: dikey ayraç x=50.2, altındaki altın çizgi
    // x 12.7–40.3 / y 15 (adres satırı) — ad çizginin üstüne, onunla hizalı.
    title: { x: 12.7, y: 8.8, w: 35, align: 'left', onDark: true },
    // Pil başlıklar ve soldaki daireler tasarımın kendisi.
    slots: [
      { name: { x: 14, y: 21.2, w: 32, h: 4.1 }, icon: { cx: 8.2, cy: 23.3, size: 6.4 }, items: { x: 4.5, y: 26.6, w: 41.5, h: 20.4 } },
      { name: { x: 63.7, y: 21.2, w: 32, h: 4.1 }, icon: { cx: 57.9, cy: 23.3, size: 6.4 }, items: { x: 54.2, y: 26.6, w: 41.5, h: 20.4 } },
      { name: { x: 14, y: 50.1, w: 32, h: 4.1 }, icon: { cx: 8.2, cy: 52.2, size: 6.4 }, items: { x: 4.5, y: 55.5, w: 41.5, h: 9.5 } },
      { name: { x: 63.7, y: 50.1, w: 32, h: 4.1 }, icon: { cx: 57.9, cy: 52.2, size: 6.4 }, items: { x: 54.2, y: 55.5, w: 41.5, h: 9.5 } },
      { name: { x: 14, y: 79.0, w: 70, h: 4.1 }, icon: { cx: 8.2, cy: 81.1, size: 6.4 }, items: { x: 16, y: 84.2, w: 68, h: 11.3, cols: 2, gap: 6 } },
    ],
  },
];

export const templateByKey = (k) => MENU_TEMPLATES.find((x) => x.key === k) || null;
/** Bölmeli şablonların kategori kapasitesi; serbest akışlıda sınır yok. */
export const slotCount = (tpl) => (tpl?.slots ? tpl.slots.length : null);
